import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateApipayGetPhones = {
  apipayPhones: { data: null, loading: false, error: null },
};

export const apipayGetPhones = createAsyncThunk(
  "payment/apipayGetPhones",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage.getItem("token");
    if (!token) return rejectWithValue({ error: "Необходима авторизация" });

    return await axios
      .get(`${process.env.REACT_APP_SERVER_API}/payments/apipay/phones/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => fulfillWithValue(res.data))
      .catch((res) =>
        rejectWithValue(
          res.response?.data || { error: "Ошибка при загрузке номеров" }
        )
      );
  }
);

export const reducerApipayGetPhones = {
  [apipayGetPhones.pending]: (state) => {
    state.apipayPhones.loading = true;
    state.apipayPhones.error = null;
  },
  [apipayGetPhones.fulfilled]: (state, action) => {
    state.apipayPhones.loading = false;
    state.apipayPhones.data = action.payload;
    state.apipayPhones.error = null;
  },
  [apipayGetPhones.rejected]: (state, action) => {
    state.apipayPhones.loading = false;
    state.apipayPhones.error = action.payload;
  },
};

